import { Navigate, useLocation } from "react-router-dom";

import { useMemberAuthStore } from "@/lib/auth/memberStore";

/** Guards /member/* routes: requires a member access token. */
export function MemberProtectedRoute({ children }: { children: React.ReactNode }) {
  const access = useMemberAuthStore((s) => s.access);
  const location = useLocation();

  if (!access) {
    return <Navigate to="/member/login" replace state={{ from: location }} />;
  }
  return <>{children}</>;
}
